import { createEnum } from '../helpers'

/**
 * Conditions that make a customer's recommended credit limit something other than the standard
 * `average weekly revenue × RCL multiplier` calculation.
 *
 * Two flavours: the fixed caps, which force a hardcoded dollar amount, and `newAccount`, whose amount
 * is computed from the province AOV per carton (see `new-accounts.ts`).
 */

/** Reasons that force one of the hardcoded amounts in `CREDIT_LIMIT_SUGGESTIONS`. */
export const CREDIT_LIMIT_FIXED_REASON_KEYS = [
  'accountInactive',
  'securityDepositPosted',
  'linkedToCentralPayer',
  'unlinkedFromCentralPayer',
] as const

export const CREDIT_LIMIT_SUGGESTION_REASON_KEYS = [
  ...CREDIT_LIMIT_FIXED_REASON_KEYS,
  'newAccount',
] as const

export const CREDIT_LIMIT_SUGGESTION_REASONS = createEnum(CREDIT_LIMIT_SUGGESTION_REASON_KEYS)
export type CreditLimitSuggestionReason = (typeof CREDIT_LIMIT_SUGGESTION_REASON_KEYS)[number]
export type CreditLimitFixedReason = (typeof CREDIT_LIMIT_FIXED_REASON_KEYS)[number]

/**
 * The capped limit each fixed condition suggests, in dollars
 */
export const CREDIT_LIMIT_SUGGESTIONS: Record<CreditLimitFixedReason, number> = {
  accountInactive: 1,
  securityDepositPosted: 2,
  linkedToCentralPayer: 3,
  unlinkedFromCentralPayer: 1,
}
